import * as i0 from '@angular/core';
import { PLATFORM_ID, Component, Inject, ContentChildren, Input, Output, NgModule } from '@angular/core';
import DxButtonGroup from 'devextreme/ui/button_group';
import * as i1 from 'devextreme-angular/core';
import { DxComponent, DxTemplateHost, WatcherHelper, NestedOptionHost, IterableDifferHelper, DxIntegrationModule, DxTemplateModule } from 'devextreme-angular/core';
import { DxiItemModule } from 'devextreme-angular/ui/nested';
import { DxiButtonGroupItemModule } from 'devextreme-angular/ui/button-group/nested';
export * from 'devextreme-angular/ui/button-group/nested';
import { PROPERTY_TOKEN_items } from 'devextreme-angular/core/tokens';

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/**
 * The ButtonGroup is a UI component that contains a set of toggle buttons and can be used as a mode switcher.

 */
let DxButtonGroupComponent = /*#__PURE__*/(() => {
  class DxButtonGroupComponent extends DxComponent {
    _watcherHelper;
    _idh;
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    instance = null;
    /**
     * Specifies the shortcut key that sets focus on the UI component.
    
     */
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    /**
     * Specifies whether the UI component changes its visual state as a result of user interaction.
    
     */
    get activeStateEnabled() {
      return this._getOption('activeStateEnabled');
    }
    set activeStateEnabled(value) {
      this._setOption('activeStateEnabled', value);
    }
    /**
     * Specifies a template for all the buttons in the group.
    
     */
    get buttonTemplate() {
      return this._getOption('buttonTemplate');
    }
    set buttonTemplate(value) {
      this._setOption('buttonTemplate', value);
    }
    /**
     * Specifies whether the UI component responds to user interaction.
    
     */
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    /**
     * Specifies the global attributes to be attached to the UI component&apos;s container element.
    
     */
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    /**
     * 
    
     */
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    /**
     * Specifies the UI component&apos;s height.
    
     */
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    /**
     * Specifies text for a hint that appears when a user pauses on the UI component.
    
     */
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    /**
     * 
    
     */
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    /**
     * Configures buttons in the group.
    
     */
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    /**
     * Specifies which data field provides keys used to distinguish between the selected buttons.
    
     */
    get keyExpr() {
      return this._getOption('keyExpr');
    }
    set keyExpr(value) {
      this._setOption('keyExpr', value);
    }
    /**
     * Switches the UI component to a right-to-left representation.
    
     */
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    /**
     * Contains keys of selected buttons and allows you to specify initial button selection state.
    
     */
    get selectedItemKeys() {
      return this._getOption('selectedItemKeys');
    }
    set selectedItemKeys(value) {
      this._setOption('selectedItemKeys', value);
    }
    /**
     * Contains the data objects that correspond to the selected buttons. The data objects are taken from the items array.
    
     */
    get selectedItems() {
      return this._getOption('selectedItems');
    }
    set selectedItems(value) {
      this._setOption('selectedItems', value);
    }
    /**
     * Specifies the button selection mode.
    
     */
    get selectionMode() {
      return this._getOption('selectionMode');
    }
    set selectionMode(value) {
      this._setOption('selectionMode', value);
    }
    /**
     * Specifies how buttons in the group are styled.
    
     */
    get stylingMode() {
      return this._getOption('stylingMode');
    }
    set stylingMode(value) {
      this._setOption('stylingMode', value);
    }
    /**
     * Specifies the number of the element when the Tab key is used for navigating.
    
     */
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    /**
     * Specifies whether the UI component is visible.
    
     */
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    /**
     * Specifies the UI component&apos;s width.
    
     */
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /**
    
     * A function that is executed when the UI component is rendered and each time the component is repainted.
    
    
     */
    onContentReady;
    /**
    
     * A function that is executed before the UI component is disposed of.
    
    
     */
    onDisposing;
    /**
    
     * A function used in JavaScript frameworks to save the UI component instance.
    
    
     */
    onInitialized;
    /**
    
     * A function that is executed when a button is clicked or tapped.
    
    
     */
    onItemClick;
    /**
    
     * A function that is executed after a UI component property is changed.
    
    
     */
    onOptionChanged;
    /**
    
     * A function that is executed when a button is selected or selection is canceled.
    
    
     */
    onSelectionChanged;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    accessKeyChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    activeStateEnabledChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    buttonTemplateChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    disabledChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    elementAttrChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    focusStateEnabledChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    heightChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    hintChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    hoverStateEnabledChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    itemsChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    keyExprChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    rtlEnabledChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    selectedItemKeysChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    selectedItemsChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    selectionModeChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    stylingModeChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    tabIndexChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    widthChange;
    constructor(elementRef, ngZone, templateHost, _watcherHelper, _idh, optionHost, transferState, platformId) {
      super(elementRef, ngZone, templateHost, _watcherHelper, transferState, platformId);
      this._watcherHelper = _watcherHelper;
      this._idh = _idh;
      this._createEventEmitters([{
        subscribe: 'contentReady',
        emit: 'onContentReady'
      }, {
        subscribe: 'disposing',
        emit: 'onDisposing'
      }, {
        subscribe: 'initialized',
        emit: 'onInitialized'
      }, {
        subscribe: 'itemClick',
        emit: 'onItemClick'
      }, {
        subscribe: 'optionChanged',
        emit: 'onOptionChanged'
      }, {
        subscribe: 'selectionChanged',
        emit: 'onSelectionChanged'
      }, {
        emit: 'accessKeyChange'
      }, {
        emit: 'activeStateEnabledChange'
      }, {
        emit: 'buttonTemplateChange'
      }, {
        emit: 'disabledChange'
      }, {
        emit: 'elementAttrChange'
      }, {
        emit: 'focusStateEnabledChange'
      }, {
        emit: 'heightChange'
      }, {
        emit: 'hintChange'
      }, {
        emit: 'hoverStateEnabledChange'
      }, {
        emit: 'itemsChange'
      }, {
        emit: 'keyExprChange'
      }, {
        emit: 'rtlEnabledChange'
      }, {
        emit: 'selectedItemKeysChange'
      }, {
        emit: 'selectedItemsChange'
      }, {
        emit: 'selectionModeChange'
      }, {
        emit: 'stylingModeChange'
      }, {
        emit: 'tabIndexChange'
      }, {
        emit: 'visibleChange'
      }, {
        emit: 'widthChange'
      }]);
      this._idh.setHost(this);
      optionHost.setHost(this);
    }
    _createInstance(element, options) {
      return new DxButtonGroup(element, options);
    }
    ngOnDestroy() {
      this._destroyWidget();
    }
    ngOnChanges(changes) {
      super.ngOnChanges(changes);
      this.setupChanges('items', changes);
      this.setupChanges('selectedItemKeys', changes);
      this.setupChanges('selectedItems', changes);
    }
    setupChanges(prop, changes) {
      if (!(prop in this._optionsToUpdate)) {
        this._idh.setup(prop, changes);
      }
    }
    ngDoCheck() {
      this._idh.doCheck('items');
      this._idh.doCheck('selectedItemKeys');
      this._idh.doCheck('selectedItems');
      this._watcherHelper.checkWatchers();
      super.ngDoCheck();
      super.clearChangedOptions();
    }
    _setOption(name, value) {
      let isSetup = this._idh.setupSingle(name, value);
      let isChanged = this._idh.getChanges(name, value) !== null;
      if (isSetup || isChanged) {
        super._setOption(name, value);
      }
    }
    /** @nocollapse */
    static ɵfac = function DxButtonGroupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxButtonGroupComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1.DxTemplateHost), i0.ɵɵdirectiveInject(i1.WatcherHelper), i0.ɵɵdirectiveInject(i1.IterableDifferHelper), i0.ɵɵdirectiveInject(i1.NestedOptionHost), i0.ɵɵdirectiveInject(i0.TransferState), i0.ɵɵdirectiveInject(PLATFORM_ID));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxButtonGroupComponent,
      selectors: [["dx-button-group"]],
      contentQueries: function DxButtonGroupComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
        }
      },
      hostAttrs: ["ngSkipHydration", "true"],
      inputs: {
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        buttonTemplate: "buttonTemplate",
        disabled: "disabled",
        elementAttr: "elementAttr",
        focusStateEnabled: "focusStateEnabled",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        items: "items",
        keyExpr: "keyExpr",
        rtlEnabled: "rtlEnabled",
        selectedItemKeys: "selectedItemKeys",
        selectedItems: "selectedItems",
        selectionMode: "selectionMode",
        stylingMode: "stylingMode",
        tabIndex: "tabIndex",
        visible: "visible",
        width: "width"
      },
      outputs: {
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onInitialized: "onInitialized",
        onItemClick: "onItemClick",
        onOptionChanged: "onOptionChanged",
        onSelectionChanged: "onSelectionChanged",
        accessKeyChange: "accessKeyChange",
        activeStateEnabledChange: "activeStateEnabledChange",
        buttonTemplateChange: "buttonTemplateChange",
        disabledChange: "disabledChange",
        elementAttrChange: "elementAttrChange",
        focusStateEnabledChange: "focusStateEnabledChange",
        heightChange: "heightChange",
        hintChange: "hintChange",
        hoverStateEnabledChange: "hoverStateEnabledChange",
        itemsChange: "itemsChange",
        keyExprChange: "keyExprChange",
        rtlEnabledChange: "rtlEnabledChange",
        selectedItemKeysChange: "selectedItemKeysChange",
        selectedItemsChange: "selectedItemsChange",
        selectionModeChange: "selectionModeChange",
        stylingModeChange: "stylingModeChange",
        tabIndexChange: "tabIndexChange",
        visibleChange: "visibleChange",
        widthChange: "widthChange"
      },
      features: [i0.ɵɵProvidersFeature([DxTemplateHost, WatcherHelper, NestedOptionHost, IterableDifferHelper]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
      decls: 0,
      vars: 0,
      template: function DxButtonGroupComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxButtonGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxButtonGroupModule = /*#__PURE__*/(() => {
  class DxButtonGroupModule {
    /** @nocollapse */static ɵfac = function DxButtonGroupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxButtonGroupModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxButtonGroupModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxButtonGroupComponent, DxiItemModule, DxiButtonGroupItemModule, DxIntegrationModule, DxTemplateModule, DxiItemModule, DxiButtonGroupItemModule, DxTemplateModule]
    });
  }
  return DxButtonGroupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DxButtonGroupComponent, DxButtonGroupModule };
